import React, { useEffect, useMemo } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import Table, { IndeterminateCheckbox } from 'components/Table';
import { ENUM_SURVEY_STATUS, ENUM_MAX_ASSIGN_THERAPIST } from 'constants/enum';

const PopupAssignTherapistTable = ({ data, setSort, sort, page, keyword, isFilter, selectedRows, setSelectedRows }) => {
  const { t } = useTranslation();

  const handleRowSelect = (rowSelect) => {
    try {
      setSelectedRows((prevSelected) => {
        // Get item index with page number
        const pageSelectedExists = _.findIndex(selectedRows, { page: page });
        const selectedRowWithPage = _.cloneDeep(prevSelected);
        // sum item is selected on the all page
        const totalSelected = prevSelected.reduce((sum, pageObj) => sum + pageObj.selected.length, 0);

        if (pageSelectedExists === -1) {
          if (totalSelected >= ENUM_MAX_ASSIGN_THERAPIST.THERAPIST) return prevSelected;
          return [
            ...prevSelected,
            {
              page: page,
              selected: [rowSelect?.original?.id],
            },
          ];
        }

        const rowIsSelected = selectedRowWithPage[pageSelectedExists]?.selected?.find((row) => row === rowSelect?.original?.id);

        /**
         * If you are select
         * - Delete the selected item from the array
         * - Delete all Object contains lines
         * - Add new object
         */
        if (rowIsSelected) {
          const selectedRemovedRow = selectedRowWithPage[pageSelectedExists].selected.filter(
            (row) => row !== rowSelect.original.id
          );

          if (selectedRemovedRow.length > 0) {
            selectedRowWithPage[pageSelectedExists].selected = selectedRemovedRow;
          } else {
            selectedRowWithPage.splice(pageSelectedExists, 1);
          }

          return selectedRowWithPage;
        }

        if (totalSelected >= ENUM_MAX_ASSIGN_THERAPIST.THERAPIST) return prevSelected;

        selectedRowWithPage[pageSelectedExists].selected = [
          ...selectedRowWithPage[pageSelectedExists].selected,
          rowSelect.original.id,
        ];

        return selectedRowWithPage;

      });
      rowSelect.getToggleSelectedHandler();
    } catch {
      // Handle error select
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: '-',
        header: () => <></>,
        size: 48,
        enableSorting: false,
        cell: ({ row }) => {
          const totalSelected = selectedRows.reduce((sum, pageObj) => sum + pageObj.selected.length, 0);
          const isChecked =
            row?.original?.status !== ENUM_SURVEY_STATUS.PUBLIC
              ? _.find(selectedRows, { page: page })?.selected?.some((item) => item === row?.original?.id)
              : false;
          const isMaxReached = totalSelected >= ENUM_MAX_ASSIGN_THERAPIST.THERAPIST && !isChecked;
          const isPublic = row.original.status === ENUM_SURVEY_STATUS.PUBLIC;
          const isDisabled = isPublic || isMaxReached;
          return (
            <div className="flex justify-center">
              <IndeterminateCheckbox
                className={`m-auto ${row.original.status !== ENUM_SURVEY_STATUS.PUBLIC ? '' : 'opacity-50 !cursor-not-allowed'}`}
                {...{
                  checked: isChecked,
                  indeterminate: false,
                  onChange: () => !isDisabled && handleRowSelect(row),
                }}
              />
            </div>
          );
        },
      },
      {
        accessorKey: 'name',
        header: ({ table }) => {
          setSort(table.getState().sorting);
          return <span>{t('NAME_THERAPIST_SETTING')}</span>;
        },
        cell: ({ row, getValue }) => {
          return <p>{getValue()}</p>;
        },
        size: 280,
        sortingFn: () => { },
      },
      {
        accessorKey: 'email',
        header: ({ table }) => {
          setSort(table.getState().sorting);
          return <span>{t('EMAIL_ADDRESS')}</span>;
        },
        cell: ({ row, getValue }) => {
          return <p>{getValue()}</p>;
        },
        size: 400,
        enableSorting: false,
      },
      {
        accessorKey: 'children_count',
        header: ({ table }) => {
          setSort(table.getState().sorting);
          return <span>{t('CHILDREN_COUNT')}</span>;
        },
        cell: ({ row, getValue }) => {
          return <p>{getValue()}</p>;
        },
        size: 280,
        enableSorting: false,
      },
    ],
    [selectedRows, page, t]
  );

  useEffect(() => {
    setSelectedRows([]);
  }, [sort, keyword]);

  return (
    <>
      <Table columns={columns} data={data} isFilter={isFilter} />
    </>
  );
};

export default React.memo(PopupAssignTherapistTable);
